import { useContext, useEffect, useState } from "react";
import { LocaleContext } from "../../contexts/LocaleContext";
import { Link, useNavigate } from "react-router-dom";
import { paymentMethodService } from "../../services/paymentMethodService";
import Loading from "../../components/common/Loading";
import InLinneLoading from "../../components/common/InlineLoading";
import DeleteConfirmation from "../../components/DeleteConfirmation";
import { toast } from "../../services/toastService";

const PaymentMethods = () => {
  const { t } = useContext(LocaleContext);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [items, setItems] = useState([]);
  const [loadingId, setLoadingId] = useState(null);
  const [deletePaymentMethodId, setDeletePaymentMethodId] = useState(null);

  useEffect(() => {
    getAllAsync();
  }, []);

  const getAllAsync = async () => {
    try {
      setLoading(true);
      const response = await paymentMethodService.getAllAsync();
      if (!response.isSuccess) {
        toast.error(t("anErrorOccurredPleaseTryAgainLater"));
        return;
      }
      setItems(response.value || []);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleToggle = async (item) => {
    setLoadingId(item.id);
    const previousItems = items;

    setItems((prev) =>
      prev.map((x) => (x.id === item.id ? { ...x, available: !x.available } : x))
    );

    try {
      const response = await paymentMethodService.toggleAvailable(item.id);
      if (!response.isSuccess) {
        setItems(previousItems);
        response.key ? toast.error(t(response.key)) : toast.error(t("anErrorOccurredPleaseTryAgainLater"));
        return;
      }
      toast.success(t("recordUpdatedSuccessfully"));
    } catch (error) {
      setItems(previousItems);
      toast.error(t("anErrorOccurredPleaseTryAgainLater"));
      console.error(error);
    } finally {
      setLoadingId(null);
    }
  };

  const handleEdit = (item) => {
    navigate("/payment-method-form", { state: { paymentMethod: item } });
  };

  const handleDelete = async () => {
    if (!deletePaymentMethodId) return;
    try {
      const response = await paymentMethodService.deleteAsync(deletePaymentMethodId);
      if (!response.isSuccess) {
        response.key ? toast.error(t(response.key)) : toast.error(t("anErrorOccurredPleaseTryAgainLater"));
        return;
      }
      toast.success(t("recordDeletedSuccessfully"));
      getAllAsync();
    } catch (error) {
      toast.error(t("anErrorOccurredPleaseTryAgainLater"));
      console.error(error);
    } finally {
      setDeletePaymentMethodId(null);
    }
  };

  if (loading) return <Loading />;

  return (
    <>
      <section className="section-payment-methods">
        <div className="default-heading">{t("paymentMethods")}</div>
        <section className="section-grid">
          <div className="grid-card">
            <div className="grid-card-header">
              <strong>{t("paymentMethodsManagement")}</strong>
              <p>{t("viewAndManageAllPaymentMethods")}</p>
            </div>
            <div className="grid-card-body">
              <div className="table-header justify-content-end">
                <div className="table-search">
                  <div className="grid-btn">
                    <Link to="/payment-method-form">
                      <button className="btn-default my-bg-secondary">
                        <i className="fas fa-plus"></i> {t("addNewPaymentMethod")}
                      </button>
                    </Link>
                  </div>
                </div>
              </div>
              <div className="table-delete-option mt-3">
                <b>{t("allPaymentMethods")}</b>
              </div>
              <div className="my-table">
                <table className="table">
                  <thead>
                    <tr>
                      <th>{t("provider")}</th>
                      <th>{t("status")}</th>
                      <th>{t("actions")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {items.map((item) => (
                      <tr key={item.id}>
                        <td>{item.provider}</td>
                        <td>
                          {loadingId === item.id ? (
                            <InLinneLoading color={"text-primary"} />
                          ) : (
                            <div className="form-check form-switch flex-center">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                id={`payment-method-switch-${item.id}`}
                                checked={item.available}
                                onChange={() => handleToggle(item)}
                              />
                              <label
                                className="form-check-label"
                                htmlFor={`payment-method-switch-${item.id}`}
                              ></label>
                            </div>
                          )}
                        </td>
                        <td>
                          <i
                            className="fas fa-ellipsis-vertical"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                          ></i>
                          <ul className="dropdown-menu">
                            <li>
                              <a
                                className="dropdown-item"
                                href="#"
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleEdit(item);
                                }}
                              >
                                <i className="fas fa-edit"></i> {t("edit")}
                              </a>
                            </li>
                            <li>
                              <a
                                className="dropdown-item"
                                href="#"
                                onClick={(e) => {
                                  e.preventDefault();
                                  setDeletePaymentMethodId(item.id);
                                }}
                                data-bs-toggle="modal"
                                data-bs-target="#my-modal"
                              >
                                <i className="fas fa-trash-alt text-danger"></i> {t("delete")}
                              </a>
                            </li>
                          </ul>
                        </td>
                      </tr>
                    ))}
                    {items.length === 0 && (
                      <tr>
                        <td colSpan="100%" className="text-center py-3">
                          {t("noResultsFound")}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </section>
      </section>
      <DeleteConfirmation t={t} handleDelete={handleDelete} />
    </>
  );
};

export default PaymentMethods;
